import { z } from 'zod';

export const BetReferralSuccessResponseSchema = z.object({
    betReferralEnabled: z.boolean(),
    betBuilderReferralEnabled: z.boolean().optional(),
});

export type SuccessResponseDataType = z.infer<typeof BetReferralSuccessResponseSchema>;

export type ResponseType =
    | {
          responseStatus: 'success';
          data: SuccessResponseDataType;
      }
    | {
          responseStatus: 'apiError';
          status: number;
          data?: unknown;
      };
